// EnVivo.jsx — sección "En vivo", feed y ticker de aportes.

import React from 'react'
import { fmtCLP, LiveDonations, LiveTicker } from '../shared.jsx'

function EnVivo({ campaign }) {
  return (
    <section id="en-vivo">
      <div className="wrap">
        <div className="section-head fade-up" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 24, marginBottom: 36 }}>
          <div>
            <div className="eyebrow"><span className="dot" />#MecanicaParaQuilpue</div>
            <h2 className="h-section" style={{ marginTop: 14 }}>
              Registro de Aportes
            </h2>
          </div>
          <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
            <div>
              <div className="kicker">Aportes totales</div>
              <div style={{ fontFamily: "var(--display)", fontSize: 28, color: "var(--fg)" }}>{fmtCLP(campaign.donors)}</div>
            </div>
            <div>
              <div className="kicker">Aporte recaudado</div>
              <div style={{ fontFamily: "var(--display)", fontSize: 28, color: "var(--fg)" }}>
                ${fmtCLP(campaign.raised)}
              </div>
            </div>
          </div>
        </div>

        <LiveDonations items={campaign.donations.slice(0, 8)} />

        <div style={{ marginTop: 56, padding: "24px 0", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
          <LiveTicker items={campaign.donations.slice(0, 14)} />
        </div>
      </div>
    </section>
  );
}

export { EnVivo };
